module.exports = __webpack_public_path__ + "static/media/Hotel-Stafler1.37770b85.png";